import * as React from "react"
import { PropsWithChildren } from "react"
import { BannerImage } from "./BannerImage/BannerImage"
import { Nav } from "./Nav"

export function Layout(props: PropsWithChildren<{}>) {
  const { children } = props

  return (
    <>
      <BannerImage />
      <Nav />
      <div className="container mb-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8">{children}</div>
        </div>
      </div>
    </>
  )
}
